var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { gql } from '@apollo/client';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import fragment from './graphql/locality-lookup.fragment';
var buildLabel = _ref => {
  var label = _ref.label,
    type = _ref.type,
    id = _ref.id,
    name = _ref.name,
    parent = _ref.parent,
    metaData = _ref.metaData;
  if (label) {
    return label;
  }
  if (type === LocalityType.POSTCODE.type) {
    return "".concat(id);
  }
  return "".concat(name).concat(parent && parent.type === LocalityType.DIVISION.type ? ", ".concat(parent.name) : '').concat(metaData && metaData.state ? ", ".concat(metaData.state) : '').concat(metaData && metaData.postcode ? ", ".concat(metaData.postcode) : '');
};
var buildLocality = _ref2 => {
  var canonicalId = _ref2.id,
    type = _ref2.type,
    canonicalSlug = _ref2.slug,
    canonicalName = _ref2.name,
    label = _ref2.label,
    alias = _ref2.alias,
    parent = _ref2.parent,
    postcode = _ref2.postcode,
    state = _ref2.state,
    centroid = _ref2.centroid,
    isCatchment = _ref2.isCatchment,
    catchmentTerm = _ref2.catchmentTerm,
    governmentCopyright = _ref2.governmentCopyright;
  var metaData = {
    postcode,
    isCatchment,
    state: state === null || state === void 0 ? void 0 : state.abbrev,
    catchmentTerm,
    governmentCopyright
  };
  var _ref3 = alias || {
      id: canonicalId,
      slug: canonicalSlug,
      name: canonicalName
    },
    id = _ref3.id,
    name = _ref3.name,
    slug = _ref3.slug;
  return {
    type,
    id,
    slug,
    name,
    label: buildLabel({
      label,
      type,
      id,
      name,
      parent,
      metaData
    }),
    parent,
    centroid,
    metaData
  };
};
export default (props, updateContext, getContext) => {
  var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query localityLookup($localities: [LocalityInput!]!) {\n      localities(localities: $localities) {\n        ...LocalityLookupFragment\n      }\n    }\n    ", "\n  "])), fragment);
  var localityLookup = function localityLookup() {
    var localityList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getContext().apolloClient.query({
      query,
      variables: {
        localities: localityList.map(_ref4 => {
          var id = _ref4.id,
            type = _ref4.type,
            slug = _ref4.slug;
          return {
            id,
            type,
            slug
          };
        })
      }
    }).then(result => {
      var _result$data;
      var localities = (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.localities) || [];
      return localities.filter(each => each).map(buildLocality);
    }).catch(() => []);
  };
  return {
    localityLookup
  };
};